import { useEffect } from 'react';

export const useEscapeKey = (callback: () => void, key?: string): void => {

  key = key || 'Escape'

  const onKeydown = (e: KeyboardEvent) => {
    if (e.code === key) callback();
  };
  
  useEffect(() => {  
    window.addEventListener('keydown', onKeydown);
    return () => window.removeEventListener('keyup', onKeydown);
  }, []);
};

export default useEscapeKey;
